import request from '@/utils/request'

function QUERY( {key, params}) {
  let url
  if(key=='CustomerWarning'){
    url = '/h5/CustomerWarning'
  }

  if (typeof params == 'object') {
    params['version'] = 'MINI'
  } else {
    params = { version: 'MINI' }
  }
  return request({
    url,
    method: 'post',
    params
  })
}

export default QUERY;